import React, { Component } from 'react'
import axios from "axios"

export class OnHoldModal extends Component {

    state = {
        onholdMessage: ""
    }


    handleUpdateMultiple = () => {
        for (let i = 0; i < this.props.crfToUpdate.length; i++) {
            axios({
                method: 'PUT',
                url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/inProcess/${this.props.crfToUpdate[i]}`,
                headers: {
                  'Api-Key':
                    '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
                  Authorization: `Bearer ${localStorage.token}`
                }
              })
                .then(response => {
                  window.location.reload()
              })
              .catch(error => {
                  console.log(error.response)   
                })
        }
    }

      handleOnHoldMessage = (e) => {
          this.setState({
              onholdMessage: e.target.value
          })
      }

     
    render() {  

        return (
            <div id="modalBody" className="modalBody">
                <div className="modalContainer" >
                    <div className="modalbg">
                        <div id="modalContentDashboard">
                            <h3 className="messageHead">Message</h3>
                            <div className="modalInputForEndorsement">
                                <h5 className="toInProcessModalHead">You are about to tag these requests as "IN PROCESS" press IN PROCESS or CANCEL.</h5>
                                
                            </div>
                            <div className="toOnHoldBtnGroup">
                                <button className="toOnholdBulkBtn" onClick={this.handleUpdateMultiple}>Confirm</button>
                                <button className="toOnholdCloseBulkBtn" onClick={this.props.handleCloseModal}>Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const textRed = {
    color: "red"
}

export default OnHoldModal
